import merge from 'lodash/merge';
import {twMerge} from '../../../common/twMerge';
import {COMMON_BOX_STYLE} from '../../../domain/content/[seriesId]/viewer/[productId]/constant/talkViewerConstant';
import {TalkShapeType} from '../../../domain/content/[seriesId]/viewer/[productId]/type/TalkShapeType.enum';
import {Text} from '../../atoms/Text/Text';
import TalkTail from '../TalkTail/TalkTail';
import {TalkShapeProps} from './TalkShapeProps.interface';

export function TalkShape({
  talkShapeType,
  talkColor,
  talkBorderColor,
  children,
  talkPosition,
  characterName,
  characterNameColor,
  hasTalkTail,
  className,
  style,
  ...props
}: TalkShapeProps) {
  return (
    <div
      className={twMerge(
        'relative',
        talkShapeType === TalkShapeType.Box && COMMON_BOX_STYLE,
        talkShapeType === TalkShapeType.Bubble && 'rounded-8tvs',
        className
      )}
      style={merge(
        {
          backgroundColor: talkColor,
          borderColor: talkBorderColor,
        },
        style
      )}
      {...props}
    >
      {hasTalkTail &&
        characterName &&
        talkShapeType === TalkShapeType.Bubble && (
          <TalkTail talkPosition={talkPosition} talkColor={talkColor} />
        )}
      {/* 박스형인 경우 캐릭터명이 박스 내부에 있으므로 별도로 처리해줍니다. */}
      {characterName && talkShapeType === TalkShapeType.Box && (
        <Text
          className="mb-12tvs block text-28tvs"
          style={{
            color: characterNameColor,
          }}
        >
          {characterName}
        </Text>
      )}
      {children}
    </div>
  );
}
